import type { AlertView } from '@chukua/common';

/** The line under an alert's status saying who answered it, or null while nobody has. A resolution outranks an acknowledgement. */
export function alertAnsweredLine(alert: Pick<AlertView, 'status' | 'resolvedBy' | 'resolvedByName' | 'acknowledgedByName'>): string | null {
  if (alert.status === 'resolved') {
    if (alert.resolvedBy === 'system') return 'Resolved by the system';
    return alert.resolvedByName ? `Resolved by ${alert.resolvedByName}` : null;
  }
  if (alert.status === 'acknowledged' && alert.acknowledgedByName) return `Acknowledged by ${alert.acknowledgedByName}`;
  return null;
}
